import React from 'react';
import { Card } from '../../../ui/molecules/Card';
import { Badge } from '../../../ui/atoms/Badge';
import { SectionHeader } from '../../../ui/molecules/SectionHeader';
import type { SkillGroup } from '../resume.types';

type SkillsSectionProps = {
  technicalSkills: SkillGroup[];
  additionalSkills: string[];
};

export function SkillsSection({
  technicalSkills,
  additionalSkills,
}: SkillsSectionProps) {
  return (
    <section className="px-4 py-16 bg-stone-100/50 dark:bg-stone-800/50" aria-labelledby="skills-heading">
      <div className="mx-auto max-w-4xl">
        <SectionHeader
          id="skills-heading"
          title="Skills"
          subtitle="React Native, Flutter, native iOS & Android, and more"
        />
        <div className="grid gap-6 md:grid-cols-2">
          {technicalSkills.map((group, cardIndex) => (
            <Card key={group.title} animationDelay={cardIndex * 60}>
              <h3 className="font-display text-lg font-semibold text-stone-800 dark:text-stone-100">
                {group.title}
              </h3>
              <div className="mt-3 flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <Badge key={item}>{item}</Badge>
                ))}
              </div>
            </Card>
          ))}
        </div>
        <div className="mt-8">
          <h3 className="font-display text-lg font-semibold text-stone-800 dark:text-stone-100 mb-3">
            Additional
          </h3>
          <ul className="flex flex-wrap gap-2">
            {additionalSkills.map((skill) => (
              <li key={skill}>
                <Badge className="bg-stone-200 text-stone-700 dark:bg-stone-600 dark:text-stone-300">{skill}</Badge>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
